import { Nullable } from '../../../types/general';
import { RegistrationProjectsSource, RegistrationSource } from '../types';

import { useUrlQueryParam } from '../../../hooks/useUrlQueryParam';
import { VALID_PROJECT_SOURCES } from './../constants';

export const useRegistrationSource = (): RegistrationSource => {
    const jwtToken = useUrlQueryParam('token');
    const source = useUrlQueryParam(
        'source',
    ) as Nullable<RegistrationProjectsSource>;

    if (source && VALID_PROJECT_SOURCES.includes(source)) {
        return source;
    }

    return jwtToken ? 'after_invite' : 'main';
};
